import tracker from 'src/api/tracker';


const sendRemoveFavorites = (offerId) => {
  tracker('send', 'removefavorites', offerId);
};

export default sendRemoveFavorites;
